import { render } from "./WhatsappComponent.vue?vue&type=template&id=dc899782"
import script from "./WhatsappComponent.vue?vue&type=script&lang=js"
export * from "./WhatsappComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Whatsapp/WhatsappComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc899782"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc899782', __exports__)) {
    api.reload('dc899782', __exports__)
  }
  
  module.hot.accept("./WhatsappComponent.vue?vue&type=template&id=dc899782", () => {
    api.rerender('dc899782', render)
  })

}


export default __exports__